import { createRouter, createWebHistory } from "vue-router";

// Importy komponent
import UserHome from "../components/UserHome.vue";
import UserAccount from "../components/UserAccount.vue";
import TipForm from "../components/TipForm.vue";
import AdminAccount from "../components/AdminAccount.vue";
import UserRegister from "../components/UserRegister.vue";
import UserLogin from "../components/UserLogin.vue";
import NotFound from "../components/NotFound.vue"; // 404 Stránka

import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const routes = [
  { path: "/", component: UserHome },
  { path: "/login", component: UserLogin },
  { path: "/register", component: UserRegister },
  {
    path: "/account",
    component: UserAccount,
    meta: { requiresAuth: true },
  },
  {
    path: "/tipovani",
    component: TipForm,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    component: AdminAccount,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  // Catch-all route pro 404 (Musí být vždy poslední!)
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Zajistí, že po kliknutí na odkaz se stránka posune úplně nahoru
  scrollBehavior() {
    return { top: 0 };
  },
});

// Vrátí Promise, která se vyřeší aktuálním uživatelem (nebo null).
// Na iOS Safari Firebase obnovuje session z IndexedDB asynchronně —
// auth.currentUser je null dokud onAuthStateChanged nepoprvé nezavolá.
function getCurrentUser() {
  return new Promise((resolve) => {
    if (auth.currentUser !== null) {
      resolve(auth.currentUser);
      return;
    }
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
}

// Globální ochrana rout (Navigation Guard)
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);

  // Čekáme na obnovení auth session — opravuje race condition na iOS Safari
  const currentUser = await getCurrentUser();

  // Zjistíme roli: localStorage jako cache, Firestore jako zdroj pravdy
  let userRole = localStorage.getItem("userRole");
  if (currentUser && !userRole) {
    // localStorage prázdný (privátní režim, ITP, nové zařízení) — načteme z Firestore
    try {
      const userDoc = await getDoc(doc(db, "users", currentUser.uid));
      if (userDoc.exists()) {
        userRole = userDoc.data().role || "user";
        localStorage.setItem("userRole", userRole);
      }
    } catch (e) {
      console.error("Chyba při načítání role:", e);
    }
  }

  // 1. Pokud stránka vyžaduje přihlášení a uživatel NENÍ přihlášen -> Login
  if (requiresAuth && !currentUser) {
    next("/login");
  }

  // 2. Pokud uživatel JE přihlášen a snaží se jít na Login nebo Register -> Account
  else if ((to.path === "/login" || to.path === "/register") && currentUser) {
    next(userRole === "admin" ? "/admin" : "/account");
  }

  // 3. Pokud stránka vyžaduje admina a uživatel není admin -> Account
  else if (requiresAdmin && userRole !== "admin") {
    next("/account");
  }

  // 4. Vše v pořádku -> Pokračuj
  else {
    next();
  }
});

export default router;
